import React, { useEffect, useState } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { toast } from "react-toastify";

import Loader from "@/shared/components/Loader";
import SupportForm from "../components/SupportForm";

import "../styles/home.css";
import supportService from "../services/supportService";

interface HomePageProps {}

const HomePage: React.FC<HomePageProps> = (props) => {
  const [captchaConfig, setCaptchaConfig] = useState<{
    key: string;
    error: boolean;
  }>({
    key: "",
    error: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  const setupCaptcha = async () => {
    setIsLoading(true);
    try {
      const config = await supportService.getRecaptchaKey();
      setCaptchaConfig({
        key: config.reCaptchaSiteKey ?? "",
        error: false,
      });
    } catch {
      setCaptchaConfig({
        key: "",
        error: true,
      });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    setupCaptcha();
  }, []);

  useEffect(() => {
    if (captchaConfig.error) {
      toast.error(
        "Captcha wasn't loaded for correct work please refresh a page"
      );
    }
  }, [captchaConfig.error]);

  return (
    <div id="wrapper">
      <Loader show={isLoading} />
      <section id="main" className="home">
        <div className="inner">
          <div className="col col-left">
            <div className="col-inner">
              <p>Simple and powerful online survey tool</p>
              <h1>Improve your customer &amp; employee satisfaction</h1>
              <ul className="list">
                <li className="ask">
                  <span className="txt">Ask</span>
                </li>
                <li className="gather">
                  <span className="txt">Gather</span>
                </li>
                <li className="analyze">
                  <span className="txt">Analyze</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="col col-right text-right">
            <GoogleReCaptchaProvider reCaptchaKey={captchaConfig.key}>
              <div className="form-holder">
                <SupportForm
                  captchaConfigError={captchaConfig.error}
                  setIsLoading={setIsLoading}
                />
              </div>
            </GoogleReCaptchaProvider>
          </div>
        </div>
      </section>
      <footer id="footer">
        <div className="inner">&copy; 2021 SatisfactionStats</div>
      </footer>
    </div>
  );
};

export default HomePage;
